import { motion } from "framer-motion";

export const ProgressBar = ({ current, total }) => {
  const pct = total > 1 ? (current / (total - 1)) * 100 : 100;
  return (
    <div className="fixed bottom-0 left-0 z-40 h-1 w-full bg-white/10" data-testid="progress-bar">
      <motion.div
        className="h-full bg-champagne"
        initial={false}
        animate={{ width: `${pct}%` }}
        transition={{ duration: 0.5, ease: [0.85, 0, 0.15, 1] }}
      />
    </div>
  );
};
